import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RentalReportLayer from '../components/RentalReportLayer'

const RentalReportPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='Rental Report' />
        <RentalReportLayer />
    </MasterLayout>
  )
}

export default RentalReportPage

